import { ElDialog as b } from "element-plus";
import { resolveComponent as h, openBlock as s, createBlock as p, mergeProps as y, withCtx as n, createElementVNode as t, renderSlot as a, createElementBlock as o, Fragment as r, createTextVNode as D, toDisplayString as c, createCommentVNode as k, normalizeStyle as C } from "vue";
import { _ as u } from "../_plugin-vue_export-helper-dad06003.js";
const S = {
  name: "rFieldsDialog",
  components: {
    Dialog: b
  },
  props: {
    /**
     * 是否显示弹窗，支持 .sync 修饰符
     */
    visible: {
      type: Boolean,
      default: !1
    },
    /**
     * 弹窗的标题,更多属性请参考[dialog](https://element.eleme.cn/#/zh-CN/component/dialog)
     */
    title: {
      type: String,
      default: "title"
    },
    labelWidth: {
      type: String,
      default: "30%"
    },
    customClass: {
      type: String,
      default: ""
    }
  },
  emits: {
    /**
     * 点击右上角关闭回调
     */
    beforeClose: null
  },
  provide() {
    return {
      labelWidth: this.labelWidth
    };
  },
  methods: {
    beforeClose() {
      this.$emit("beforeClose");
    }
  }
}, $ = /* @__PURE__ */ t(
  "span",
  null,
  null,
  -1
  /* HOISTED */
);
function F(e, f, l, v, _, i) {
  const g = h("Dialog");
  return s(), p(g, y(e.$attrs, {
    "model-value": l.visible,
    "custom-class": l.customClass ? `r-fields-dialog ${l.customClass}` : "r-fields-dialog",
    "before-close": i.beforeClose
  }), {
    title: n(() => [
      t("span", null, [
        e.$slots.title ? a(e.$slots, "title", { key: 0 }) : (s(), o(
          r,
          { key: 1 },
          [
            D(
              c(l.title),
              1
              /* TEXT */
            )
          ],
          64
          /* STABLE_FRAGMENT */
        ))
      ])
    ]),
    footer: n(() => [
      $
    ]),
    default: n(() => [
      l.visible ? a(e.$slots, "default", { key: 0 }) : k("v-if", !0)
    ]),
    _: 3
    /* FORWARDED */
  }, 16, ["model-value", "custom-class", "before-close"]);
}
const d = /* @__PURE__ */ u(S, [["render", F], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/fields-dialog/fields-dialog.vue"]]), W = {
  name: "rFieldsDialogItem",
  props: {
    label: String,
    value: {
      type: [Number, String],
      default: ""
    }
  },
  inject: ["labelWidth"],
  mounted() {
  },
  emits: ["update:value"]
}, B = { class: "r-fields-dialog-item" }, N = { class: "label" }, E = { class: "value" }, V = { class: "value" };
function w(e, f, l, v, _, i) {
  return s(), o("div", B, [
    l.label || l.value ? (s(), o(
      r,
      { key: 0 },
      [
        t(
          "div",
          N,
          c(l.label),
          1
          /* TEXT */
        ),
        t(
          "div",
          E,
          c(l.value),
          1
          /* TEXT */
        )
      ],
      64
      /* STABLE_FRAGMENT */
    )) : (s(), o(
      r,
      { key: 1 },
      [
        t(
          "div",
          {
            class: "label",
            style: C({ width: i.labelWidth })
          },
          [
            a(e.$slots, "label")
          ],
          4
          /* STYLE */
        ),
        t("div", V, [
          a(e.$slots, "value")
        ])
      ],
      64
      /* STABLE_FRAGMENT */
    ))
  ]);
}
const m = /* @__PURE__ */ u(W, [["render", w], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/fields-dialog/fields-dialog-item.vue"]]);
d.install = function(e) {
  e.component(d.name, d), e.component(m.name, m);
};
export {
  d as default
};
